/**
 * Proposed sidebar entries for the inventory feature — a contribution file
 * the shell merges into its route registry; nothing self-registers.
 * Permission strings are the canonical codes from
 * `openapi/generated/route_policy.gen.go`.
 */
import {
  Boxes,
  ClipboardList,
  Hourglass,
  PackageSearch,
  Timer,
  Truck,
  Warehouse,
} from "lucide-react";

import type { NavEntry } from "@/app-shell/route-registry";

export const inventoryNavEntries: NavEntry[] = [
  {
    path: "/inventory",
    labelKey: "inventory.nav.group",
    icon: Boxes,
    children: [
      {
        path: "/inventory/stock",
        labelKey: "inventory.nav.stock",
        icon: PackageSearch,
        permission: "inventory.stock.read",
      },
      {
        path: "/inventory/movements",
        labelKey: "inventory.nav.movements",
        icon: Boxes,
        permission: "inventory.movement.read",
      },
      {
        path: "/inventory/transfers",
        labelKey: "inventory.nav.transfers",
        icon: Truck,
        permission: "inventory.transfer.read",
      },
      {
        path: "/inventory/counts",
        labelKey: "inventory.nav.counts",
        icon: ClipboardList,
        permission: "inventory.count.read",
      },
      {
        path: "/inventory/warehouses",
        labelKey: "inventory.nav.warehouses",
        icon: Warehouse,
        permission: "inventory.warehouse.read",
      },
      {
        path: "/inventory/reports/dead-stock",
        labelKey: "inventory.nav.deadStock",
        icon: Hourglass,
        permission: "inventory.report.read",
      },
      {
        path: "/inventory/reports/slow-movers",
        labelKey: "inventory.nav.slowMovers",
        icon: Timer,
        permission: "inventory.report.read",
      },
    ],
  },
];
